var scrollWithDelay = function scrollWithDelay(scrollRef, scrollBehavior) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  setTimeout(function () {
    var _scrollRef$current;
    (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.scrollTo(scrollBehavior);
  }, delay);
};

export { scrollWithDelay };
//# sourceMappingURL=scrollWithDelay.js.map
